<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <businessLetters-add
          @handleAddBusinessLetter="handleAddBusinessLetter"
          @handleEditBusinessLetter="handleEditBusinessLetter"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import BusinessLetters from "@/services/businessLetters.service";
import { notify } from "@/helpers/notify";
import TitleBar from "@/components/TitleBar";
import CardComponent from "@/components/CardComponent";
import BusinessLettersAdd from "../components/businessLetters/businessLetters-add.vue";

export default {
  name: "BusinessLetter",
  components: { TitleBar, CardComponent, BusinessLettersAdd },
  data() {
    return {
      editMode: false,
    };
  },
  methods: {
    async handleAddBusinessLetter(businessLetter) {
      try {
        const { handleAddBusinessLetter } = BusinessLetters;
        const response = await handleAddBusinessLetter(businessLetter);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Documentul a fost adaugat.");
          this.$router.push({ path: "/BusinessLetters" });
        } else {
          notify.error(this, "Eroare la adaugarea documentului.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async handleEditBusinessLetter(businessLetter) {
      try {
        const { handleEditBusinessLetter } = BusinessLetters;
        const response = await handleEditBusinessLetter(businessLetter);
        notify.success(this, "Documentul a fost modificat.");
        this.$router.push({ path: "/BusinessLetters" });
      } catch (error) {
        notify.error(this, "Eroare la modificarea documentului.");
      }
    },
  },
  computed: {
    titleStack() {
      const parent = { label: "Documente", to: "/BusinessLetters" };
      if (this.editMode) {
        return [parent, "Editare document"];
      } else {
        return [parent, "Adaugare document"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare document";
      } else {
        return "Adaugare document";
      }
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    if (id) {
      this.editMode = true;
    } else {
      // this.announcement.date = new Date();
    }
  },
};
</script>
